import { Typography, useTheme } from "@mui/material";
import maintenance from "assets/animations/maintenance.json" with { type: "json" };
import { ModalContentWrapper } from "components/primitives/ModalContentWrapper";
import { ModalTitle } from "components/primitives/ModalTitle";
import { useMixpanelTrackers } from "hooks/useMixpanelTrackers";
import { useAppSelector } from "hooks/utilsHooks/storeHooks";
import Lottie from "lottie-react";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { selectShortFridgeId } from "slices/fridgeInfoSlice";
import { logToSentry } from "utils/logger";
import { BasicModal } from "./BasicModal";
import { ModalSupportFooter } from "./ModalSupportFooter";

const RemoteRefillModalContent = () => {
	const fridgeId = useAppSelector(selectShortFridgeId);
	const { t } = useTranslation();
	const theme = useTheme();
	const { trackRemoteRefillModal } = useMixpanelTrackers();

	useEffect(() => {
		logToSentry(`Remote refill modal displayed on fridge: ${fridgeId}`, "info");
		trackRemoteRefillModal("open");

		return () => {
			trackRemoteRefillModal("close");
		};
	}, [fridgeId, trackRemoteRefillModal]);

	return (
		<ModalContentWrapper>
			<ModalTitle variant="promoHeader">{t("modals.remoteRefill.title" as never)}</ModalTitle>
			<Typography variant="promoText" sx={{ marginRight: "auto", marginBottom: 10 }}>
				{t("modals.remoteRefill.description" as never)}
			</Typography>
			<Lottie animationData={maintenance} loop={true} />
			<ModalSupportFooter fridgeId={fridgeId} background={theme.palette.copper.main} />
		</ModalContentWrapper>
	);
};

export const RemoteRefillModal = () => (
	<BasicModal modalContent={<RemoteRefillModalContent />} open={true} closable={false} fullHeight={true} />
);
